import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=6724a20f&scoped=true"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"
import style0 from "./ProductManage.vue?vue&type=style&index=0&id=6724a20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724a20f",
  null
  
)

export default component.exports